<template>
  <modal :show.sync="modal" @close="onModalClose">
    <form class="ml-3 mt-3 mr-3 mb-3">
      <h4 class="text-center">PIX</h4>
      <div class="col-md-12 text-center">
        <div class="image-container">
          <img :src="invoiceCharge.qrCode" alt="QR Code" />
        </div>
      </div>
      <div class="pix-copy-paste-container mt-3">
        <div class="input-group">
          <input type="text" class="form-control" v-model="invoiceCharge.pixCopyPaste" readonly>
          <div class="input-group-append">
            <button class="btn btn-outline-secondary" type="button" @click="copyPixCode">
              <i class="fas fa-copy"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="col-md-12 text-center">
        <span style="color: #8492a6;">
          Tempo restante: {{ remainingTime }}
        </span>
      </div>
      <div class="col-md-12 text-center">
        <span style="color: #8492a6;">
          <span> Valor: {{ Intl.NumberFormat('pt-BR', {style: 'currency', currency:
            'BRL'}).format(invoiceCharge.amount) }}</span>
        </span>
      </div>
      <div class="col-md-12 text-center mt-3">
        <button type="button" class="btn btn-primary" @click="fetchApiData">Já pagou</button>
      </div>
      <div class="col-md-12 text-center">
        <span style="color: #8492a6; font-size:10px">
          * Avise ao cliente que terá 60 minutos para realizar o pagamento, após isso será cancelado o pix e deverá ser
          criado outro
        </span>
      </div>
    </form>
  </modal>
</template>
<script>
import { differenceInSeconds } from 'date-fns';

export default {
  name: 'subscription-pix-cr-code-modal',
  props: ['invoiceCharge', 'invoiceId'],
  emits: ['onClose', 'onChange'],
  data() {
    return {
      timer: null,
      expirationTimer: null,
      currentState: null,
      modal: false,
      remainingTime: ''
    };
  },
  watch: {
    invoiceCharge(newVal) {
      if (newVal.chargeId) {
        this.modal = true;
        this.startPolling();
        this.startExpirationTimer();
      } else {
        this.modal = false;
      }
    },
    modal(newVal) {
      if (!newVal) {
        this.stopPolling();
        this.stopExpirationTimer();
      }
    }
  },
  methods: {
    closeModal() {
      this.$emit('onClose');
    },
    onModalClose() {
      this.$emit('onClose');
    },
    startPolling() {
      this.fetchApiData();
      this.timer = setInterval(this.fetchApiData, 5000);
    },
    stopPolling() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    fetchApiData() {
      this.$clubApi.put(`/invoice/${this.invoiceId}/charge/${this.invoiceCharge.chargeId}/sync`)
        .then((response) => this.ensurePayment(response.data.object))
        .catch((error) => this.$notify({ type: 'warning', message: error.response.data.msg }))
        .finally(() => NProgress.done());
    },
    ensurePayment(value) {
      this.currentState = value;

      switch (this.currentState.status) {
        case 'PAID':
          this.$notify({ type: 'success', message: "Fatura paga com sucesso." });
          this.$emit('onChange');
          this.closeModal();
          break;
        case 'EXPIRED':
          this.$notify({ type: 'error', message: "O tempo para pagar o pix acabou" });
          break;
        case 'WAITING':
          // Não faz nada, pois o polling continua
          return;
        default:
          this.$notify({ type: 'warning', message: "Status de pagamento desconhecido." });
      }

      this.stopPolling();
      this.closeModal();
    },
    startExpirationTimer() {
      this.updateRemainingTime();
      this.expirationTimer = setInterval(this.updateRemainingTime, 1000);
    },
    stopExpirationTimer() {
      if (this.expirationTimer) {
        clearInterval(this.expirationTimer);
        this.expirationTimer = null;
      }
    },
    updateRemainingTime() {
      const now = new Date();
      let expireAt;

      try {
        // Parse the date string manually
        const [datePart, timePart] = this.invoiceCharge.expireAt.split(' ');
        const [day, month, year] = datePart.split('/');
        const [hours, minutes, seconds] = timePart.split(':');

        expireAt = new Date(year, month - 1, day, hours, minutes, seconds);

        if (isNaN(expireAt.getTime())) {
          throw new Error('Invalid date');
        }
      } catch (error) {
        console.error('Error parsing date:', error, this.invoiceCharge.expireAt);
        this.remainingTime = 'Data inválida';
        this.stopExpirationTimer();
        return;
      }

      const diffInSeconds = differenceInSeconds(expireAt, now);

      if (diffInSeconds <= 0) {
        this.remainingTime = 'Expirado';
        this.stopExpirationTimer();
      } else {
        const minutes = Math.floor(diffInSeconds / 60);
        const seconds = diffInSeconds % 60;
        this.remainingTime = `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
      }
    },
    copyPixCode() {
      navigator.clipboard.writeText(this.invoiceCharge.pixCopyPaste)
        .then(() => {
          this.$notify({ type: 'success', message: 'Código Pix copiado com sucesso!' });
        })
        .catch(() => this.$$notify({ type: 'warning', message: 'Erro ao copiar o código Pix.' }));
    }
  },
  beforeDestroy() {
    this.stopPolling();
    this.stopExpirationTimer();
  }
}
</script>
<style scoped>
.payment-buttons-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
}

.payment-button-wrapper {
  flex: 0 0 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.btn-payment {
  width: 200px;
  height: 200px;
  background-color: white;
  border: 2px solid rgba(0, 0, 0, 0.125);
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.btn-payment:hover {
  background-color: #f8f9fa;
  border-color: #999;
}

.payment-icon {
  font-size: 4rem;
  margin-bottom: 20px;
}

/* Responsividade para telas menores */
@media (max-width: 768px) {
  .payment-buttons-container {
    flex-direction: column;
    height: auto;
  }

  .payment-button-wrapper {
    flex: 0 0 100%;
    margin-bottom: 20px;
  }

  .btn-payment {
    width: 180px;
    height: 180px;
  }

  .payment-icon {
    font-size: 3rem;
  }
}

.table td {
  vertical-align: middle;
}

.image-container {
  width: 300px;
  height: 300px;
  overflow: hidden;
  margin-left: auto;
  margin-right: auto;
}

.image-container img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.pix-copy-paste-container {
  width: 100%;
  max-width: 400px;
  margin: 0 auto;
}

.input-group {
  display: flex;
}

.input-group .form-control {
  flex: 1;
}

.input-group-append .btn {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgb(206, 212, 218);
  padding: 0.625rem 0.925rem;
}

.input-group-append .btn i {
  margin-right: 0px;
}
</style>